<script setup>
import { useAppStore } from '~/store/main'
import xroadTextsQuery from '~/assets/gql/xroadTexts.gql'

const store = useAppStore()
const { getStudiumNav, getAcademyNav, getProgramNav } = storeToRefs(store)
const localePath = useLocalePath()
const { locale } = useI18n()

const { result: queryData } = useQuery(xroadTextsQuery, {
  language: locale.value.toUpperCase(),
  fetchPolicy: 'network-only',
  clientId: 'default',
})

const data = computed(() => queryData.value?.articles?.nodes[0])
</script>

<template>
  <div v-if="data?.GlobalAttributes?.xroadTexts?.length" class="mainCategories">
    <div
      v-if="getStudiumNav?.[0]?.connectedNode"
      class="mainCategories__column"
    >
      <NuxtLink
        :to="
          localePath({
            name: 'article-slug',
            params: { slug: getStudiumNav[0].connectedNode.node.slug },
          })
        "
        class="link"
      >
        <span
          v-if="data.GlobalAttributes.xroadTexts[0]?.text"
          class="text_home text0"
          v-html="data.GlobalAttributes.xroadTexts[0].text"
        />
      </NuxtLink>
    </div>
    <div
      v-if="getAcademyNav?.[0]?.connectedNode"
      class="mainCategories__column"
    >
      <NuxtLink
        :to="
          localePath({
            name: 'article-slug',
            params: { slug: getAcademyNav[0].connectedNode.node.slug },
          })
        "
        class="link"
      >
        <span
          v-if="data.GlobalAttributes.xroadTexts[1]?.text"
          class="text_home text1"
          v-html="data.GlobalAttributes.xroadTexts[1].text"
        />
      </NuxtLink>
    </div>
    <div
      v-if="getProgramNav?.[0]?.connectedNode"
      class="mainCategories__column"
    >
      <NuxtLink
        :to="
          localePath({
            name: 'article-slug',
            params: { slug: getProgramNav[0].connectedNode.node.slug },
          })
        "
        class="link"
      >
        <span
          v-if="data.GlobalAttributes.xroadTexts[2]?.text"
          class="text_home text2"
          v-html="data.GlobalAttributes.xroadTexts[2].text"
        />
      </NuxtLink>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mainCategories {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: stretch;

  &__column {
    flex: 1;
    padding: 0 20px;
    border-right: 1px solid $color-5;

    &:first-child {
      padding-inline-start: 0px;
    }
    &:last-child {
      border: none;
      padding-inline-end: 0;
    }
  }
}

.text0 {
  &:deep(a) {
    color: $color-red !important;
  }
  &:deep(p) {
    color: $color-red !important;
    &:hover {
      color: $color-2 !important;
    }
  }
}

.text1 {
  &:deep(a) {
    color: $color-green !important;
  }
  &:deep(p) {
    color: $color-green !important;
    &:hover {
      color: $color-2 !important;
    }
  }
}

.text2 {
  &:deep(a) {
    color: $color-blue !important;
  }
  &:deep(p) {
    color: $color-blue !important;
    &:hover {
      color: $color-2 !important;
    }
  }
}
</style>
